import React from "react";
import { motion, useTransform } from "framer-motion";

import "./timeline-progressbar.scss";

const TimelineProgressBar = ({scrollYProgress, thresholds}) => {

  const progressWidth = useTransform(
    scrollYProgress,
    [0, 1],
    ["0.001vw", "96vw"]
  );

  const progressLeft = useTransform(
    scrollYProgress,
    [0, 0.1],
    ["25vw", "5vw"]
  );
  
  return (
      <motion.div className="timeline-progressbar"
        style={{ left: progressLeft }}
      >
        <motion.div
          style={{ width: progressWidth }}
          className="timeline-progressbar__progress"
        >
        </motion.div>
        <div className="timeline-progressbar__bg"></div>
        <div className="timeline-progressbar__divisions">
          {thresholds.map(threshold=>{
            return (<span key={`division${threshold}`} style={{left:`${threshold*100}%`}}></span>);
          })}
        </div>
      </motion.div>
  );
};

export default TimelineProgressBar;